import { Box } from "@mui/material";
import { useContactCenterTheme } from "../../../../virtual-receptionist/theming/ContactCenterThemeContext";
import { AudioPlayerBar } from "@components/shared/components/audio-player/AudioPlayerBar";

export const MessageAudio = ({ message }) => {
  const { theme } = useContactCenterTheme();
  const surface = theme.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)";

  const audioUrl = message?.content?.file;
  const duration = message?.content?.duration || 0;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { sm: "20px%", md: "100%" },
        p: 1,
        borderRadius: 3,
        backgroundColor: surface,
        color: "inherit",
      }}
    >
      <AudioPlayerBar
        src={audioUrl}
        initialDuration={duration}
        playButtonSx={{
          width: 38,
          height: 38,
          borderRadius: "50%",
          backgroundColor: theme.shell.accent,
          color: "#fff",
          "&:hover": { backgroundColor: theme.shell.accent, opacity: 0.85 },
        }}
        sliderSx={{
          color: theme.shell.accent,
          height: 4,
          py: 0.5,
          "& .MuiSlider-thumb": {
            width: 12,
            height: 12,
          },
          "& .MuiSlider-rail": {
            opacity: 0.35,
            bgcolor: theme.chat.scrollThumb,
          },
          "& .MuiSlider-track": {
            border: "none",
          },
        }}
        timeLabelSx={{
          fontSize: "0.75rem",
          fontWeight: 500,
          color: "inherit",
          opacity: 0.75,
        }}
      />
    </Box>
  );
};
